'use client';

import { CourierNotifications } from './CourierNotifications';
import * as Styled from './NavActions.styled';
import { DropdownContent } from './components/Dropdown/Dropdown';
import { SystemRolesBadgeDropdownComponent as SystemRolesBadgeDropdown } from './components/SystemRolesBadgeDropdown/SystemRolesBadgeDropdown';
import { SupportDrawer } from 'app/(authenticated)/_components/NavActions/components/SupportDrawer/SupportDrawer';
import { useUser } from 'app/_providers/User';

import { Tooltip } from 'antd';
import React from 'react';

type Props = Readonly<{
  userInitials: string;
  hideProfile?: boolean;
}>;

export const NavActions: React.FC<Props> = ({ userInitials, hideProfile }) => {
  const user = useUser();
  const [accountPopoverOpen, setAccountPopoverOpen] = React.useState(false);

  return (
    <Styled.AccountActions>
      <CourierNotifications user={user} />

      <SupportDrawer />

      <SystemRolesBadgeDropdown />

      {userInitials?.length > 0 && (
        <Styled.PopoverWrap>
          {(className) => (
            <Styled.AccountPopover
              placement='bottomRight'
              content={
                <DropdownContent
                  closePopover={() => setAccountPopoverOpen(false)}
                  hideProfile={hideProfile}
                />
              }
              classNames={{
                root: className,
              }}
              title={<div>Account</div>}
              open={accountPopoverOpen}
              trigger='click'
              onOpenChange={(open) => setAccountPopoverOpen(open)}
            >
              <Styled.UserIconWrapper id='profile-icon'>
                <Tooltip
                  title='Account'
                  classNames={{
                    root: className,
                  }}
                >
                  <Styled.StyledAvatar
                    size='small'
                    gap={2}
                  >
                    {userInitials.toUpperCase()}
                  </Styled.StyledAvatar>
                </Tooltip>
              </Styled.UserIconWrapper>
            </Styled.AccountPopover>
          )}
        </Styled.PopoverWrap>
      )}
    </Styled.AccountActions>
  );
};
